import styled from 'styled-components';

export const CardTag = styled.article`
  color: ${({ theme }) => theme.black};
  
  &:hover h3 {
    color: ${({ theme }) => theme.blue};
  }
`;

export const CardImageContainer = styled.header`
  position: relative;
  
  height: 160px;
  margin-bottom: 15px;
  
  border-radius: 6px;
  
  overflow: hidden;
  
  &::before {
    content: "";
    
    position: absolute;
    top: 0;
    right: 0;
    
    width: 100%;
    height: 100%;
    
    background-image: linear-gradient(180deg, rgba(0, 0, 0, 0.65) 0%, rgba(0, 0, 0, 0.08) 20%);
  }
  
  img {
    width: 100%;
    height: 100%;
    object-fit: cover;
  }
`;

export const CardType = styled.span`
  position: absolute;
  top: 0;
  left: 0;
  
  padding: 5px 10px;
  
  font-weight: 700;
  font-size: 12px;
  line-height: 1;
  text-align: center;
  color: ${({ theme }) => theme.white};
  
  border-radius: 6px 0 6px 0;
  
  background-color: ${({ theme, type }) => {
    switch (type) {
      case "Festive":
        return theme.red;
      case "Tranquil":
        return theme.green;
      case "Family":
        return theme.blue;
      default:
        return theme.blue;
    }  
  }};
`;

export const CardInfo = styled.div`
  display: flex;
  flex-wrap: wrap;
  align-items: center;
`;

export const CardHeading = styled.h3`
  width: 100%;
  margin: 0;
  margin-bottom: 15px;
  padding: 0;
  
  font-size: 15px;
  line-height: 16px;
  
  transition: color 0.3s;
`;

export const CardWay = styled.span`
  margin-bottom: 10px;
  padding: 3px 10px;
  
  font-size: 12px;
  line-height: 1;
  color: ${({ theme }) => theme.white};
  
  background-color: ${({ theme }) => theme.blue};
  border-radius: 50px;
`;

export const CardLocation = styled.span`
  display: inline-block;
  margin-bottom: 15px;
  
  font-size: 12px;
  line-height: 1;
`;

export const CardFooter = styled.footer`
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  width: 100%;
`;

export const CardRatingWrapper = styled.span`
  position: absolute;
  top: 10px;
  right: 10px;
  
  display: flex;
  align-items: center;
  
  font-weight: 700;
  font-size: 12px;
  color: ${({ theme }) => theme.white};
`;

export const CardVotes = styled.p`
  margin: 0;
  margin-left: 5px;
  padding: 0;
`;

export const CardDiscount = styled.span`
  position: absolute;
  bottom: 0;
  left: 0;
  
  padding: 7px 15px;
  
  font-weight: 700;
  font-size: 14px;
  
  background-color: ${({ theme }) => theme.yellow};
  box-shadow: 0 0 20px rgba(254, 211, 45, 0.24);
  border-top-right-radius: 6px;
`;

export const CrossedPrice = styled.span`
  margin-right: 10px;
  
  font-size: 16px;
  text-decoration: line-through;
`;

export const CardWithDiscountPrice = styled.p`
  margin: 0;
  padding: 5px 10px;
  
  font-weight: 700;
  font-size: 12px;
  line-height: 1;
  
  background-color: ${({ theme }) => theme.yellow};
  border-radius: 50px;
  
  span {
    font-size: 15px;
  }
`;

export const CardPrice = styled.p`
  margin: 0;
  padding: 0;
  
  font-weight: 700;
  font-size: 12px;
  line-height: 1;
  
  span {
    font-size: 17px;
  }
`;
